import React, { useState, useRef, useEffect } from 'react';
import { Card, Grid, Button, Box, Modal, Typography, TextField } from '@mui/material';
import { Link } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';
import history from 'history.js';
import useAuth from 'app/hooks/useAuth';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import BotaoArredondado from 'app/components/BotaoArredondado';
import queryString from 'query-string';
import "./style.scss";
// import { useQuery } from "../../utils";
import PasswordScreen from "app/components/SignIn/passwordScreen";
import OnBoardingPainel from "app/components/OnboardingPainel";
import { AnimatePresence } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import { useToastify } from 'app/hooks/useToastify';

const useStyles = makeStyles(({ palette, ...theme }) => ({
    cardHolder: {
        background: '#1A2038',
    },
    card: {
        width: 500,
        borderRadius: 12,
        margin: '1rem',
        padding: '1.5rem',
        height: 'auto',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: '1.5rem',
        width: '100%',
        height: '100%',
    },
    divBotao: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    mod: {
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 500,
        border: '2px solid #000',
        borderRadius: '25px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        backgroundColor: 'white',
        padding: '1rem',
        textAlign: 'center',
        justifyContent: 'center',
        gap: '1rem',
    },
    bMod: {
        width: '100vw',
        height: '100vh',
        zIndex: -1,
        backgroundColor: 'rgba(100, 100, 100, 0.5)',
    },
    headerForgot: {
        textAlign: 'center',
    },
}));

const ResetPassword = () => {
    const classes = useStyles();
    const { resetpassword } = useAuth();
    const [token, setToken] = useState('');
    const [open, setOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalText, setModalText] = useState('');
    const [passwordIsChanged, setPasswordIsChanged] = useState(false);

    const toast = useToastify();

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        if (passwordIsChanged) {
            returnURL();
        } else {
            setOpen(false);
        }
    };

    const validationSchema = Yup.object().shape({
        senha: Yup.string().min(6, 'A senha precisa ter no mínimo 6 caracteres').required('Preenchimento obrigatório.'),
        senhaConfirmacao: Yup.string()
            .oneOf([Yup.ref('senha'), null], 'As senhas não podem ser diferentes.')
            .required('Preenchimento obrigatório.'),
    });

    const handleFormSubmit = async (values) => {
        try {
            const response = await resetpassword(token, values.senha);

            if (response.status == 204) {
                return true
            } else if (response.status == 412){
                throw new Error("Token expirado.")
            } else {
                throw new Error("Erro ao redefinir senha.")
            }
        } catch (err) {
            console.error(err)
            toast.show("error", err.message ?? "Erro ao redefinir senha.")
            return false
        }
    };

    const returnURL = () => {
        history.push('/session/signin');
    };

    useEffect(() => {
        const params = queryString.parse(window.location.search);
        if (!params.token) {
            returnURL();
        }
        setToken(params.token);
    }, []);

    return (

        <section>
            <ToastContainer />
            <div className="tw-grid tw-grid-cols-2 tw-h-screen">
                <OnBoardingPainel />
                <AnimatePresence>
                    <PasswordScreen token={token} resetPasword={handleFormSubmit}/>
                </AnimatePresence>
            </div>
        </section>
        // <div>
        //     <div
        //         className={clsx(
        //             'flex justify-center items-center  min-h-full-screen',
        //             classes.cardHolder
        //         )}
        //     >
        //         <Card className={classes.card}>
        //             <div className="mb-4">
        //                 <h3 className={classes.headerForgot}>Definição de Senha</h3>
        //             </div>
        //             <Formik
        //                 initialValues={{ senha: '', senhaConfirmacao: '' }}
        //                 validationSchema={validationSchema}
        //                 onSubmit={handleFormSubmit}
        //             >
        //                 {({ isSubmitting }) => (
        //                     <Form className={classes.form}>
        //                         <Field
        //                             as={TextField}
        //                             name="senha"
        //                             label="Nova Senha"
        //                             type="password"
        //                             variant="outlined"
        //                             size="small"
        //                             fullWidth
        //                         />
        //                         <ErrorMessage name="senha" component="div" className="text-error" />
                                
        //                         <Field
        //                             as={TextField}
        //                             name="senhaConfirmacao"
        //                             label="Confirmar Nova Senha"
        //                             type="password"
        //                             variant="outlined"
        //                             size="small"
        //                             fullWidth
        //                         />
        //                         <ErrorMessage name="senhaConfirmacao" component="div" className="text-error" />

        //                         <div className={classes.divBotao}>
        //                             <BotaoArredondado value="Confirmar" disabled={isSubmitting} />
        //                         </div>
        //                     </Form>
        //                 )}
        //             </Formik>
        //         </Card>
        //     </div>
        //     <div>
        //         <Modal
        //             className={classes.bMod}
        //             open={open}
        //             onClose={handleClose}
        //             aria-labelledby="modal-modal-title"
        //             aria-describedby="modal-modal-description"
        //         >
        //             <Box className={classes.mod}>
        //                 <Typography id="modal-modal-title" variant="h6" component="h2">
        //                     {modalTitle}
        //                 </Typography>
        //                 <Typography id="modal-modal-description">{modalText}</Typography>
        //                 <Button variant="contained" color="primary" onClick={handleClose}>
        //                     OK
        //                 </Button>
        //             </Box>
        //         </Modal>
        //     </div>
        // </div>
    );
};

export default ResetPassword;
